// 用户广告统计列表
import request from '@/utils/request';
export function getUserActiveList(data) {
  return request({
    url: '/data/ad_summary',
    method: 'get',
    params: data
  });
}